var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg65Bc8A2Da047A0E46256D596Devops(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 165,
    viewBox: "0 0 348 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346.789 82.1842C346.789 126.707 312.095 162.802 269.272 162.802C269.272 162.802 209.951 164.13 176.732 82.6155C139.731 -8.17118 79.4423 1.54946 79.4423 1.54946C36.6192 1.54946 1.92603 37.6452 1.92603 82.1842C1.92603 126.707 36.6341 162.819 79.4423 162.819C79.4423 162.819 139.731 172.54 176.732 81.7364C209.966 0.28876 269.272 1.61581 269.272 1.61581C312.08 1.61581 346.789 37.7115 346.789 82.2506V82.1842Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg65Bc8A2Da047A0E46256D596Devops);
export default __webpack_public_path__ + "static/media/65bc8a2da047a0e46256d596_devops.0d7c31c4def2fe83bf571e0553d99472.svg";
export { ForwardRef as ReactComponent };